import { AddToCartStyleTokens } from "@omni/ui/brand/modals/addToCart/addToCart.tokens";

export const AddToCartStyles: AddToCartStyleTokens = {
    goToCartButton: {
        color: "primary"
    }
};
